module.exports = __webpack_public_path__ + "a215ba6bea556c21bfcbf4072fd9d52d.pdf";